export default {
  'Filtros de búsqueda': 'Filtres de cerca',
  'Equipo 1': 'Equip 1',
  'Equipo 2': 'Equip 2',
  'Competición': 'Competició',
  'Temporada': 'Temporada',
  'Buscar': 'Cercar',
  'Borrar': 'Esborrar',
  'Filtrar resultados': 'Filtrar resultats',
  'Resultados': 'Resultats',
  'Realizar Pedido': 'Realitzar Comanda',
  'Cancelar': 'Cancel·lar',
  'Enviar': 'Enviar',
  'Enviar mensaje': 'Enviar missatge',
  'Pedido enviado correctamente!': 'Comanda enviada correctament!',
  'Ha ocurrido un error': 'S\'ha produït un error',
  'Nombre': 'Nom',
  'Nombre competo': 'Nom complet',
  'Confirmar pedido': 'Confirmar comanda',
  'Finalizar pedido': 'Finalitzar comanda',
  'Mensaje adicional': 'Missatge addicional',
  'E-mail': 'Correu electrònic',
  'Observaciones': 'Observacions',
  'Partidos seleccionados': 'Partits seleccionats',
  'Pedido': 'Comanda',
  'El campo es obligatorio': 'El camp és obligatori',
  'El correo debe ser válido': 'El correu ha de ser vàlid.',
  'Buscador': 'Cercador',
  'Precios y formas de envío': 'Preus i formes d’enviament',
  'Más partidos': 'Més partits',
  'Resúmenes': 'Resums',
  'Contacto': 'Contacte',
  'Contacta con nosotros': 'Contacta amb nosaltres',
  'Métodos de pago aceptados': 'Mètodes de pagament acceptats',
  'Ofertas especiales': 'Ofertes especials',
  '5€ por partido': '5€ per partit',
  'Descarga digital': 'Descàrrega digital',
  'Precios por partido': 'Preus per partit',
  'Enviado correctamente!': 'Enviat correctament!',
  'Oferta': 'Oferta',
  '100 partidos por': '100 partits per',
  'Transferencia': 'Transferència',
  'Mensaje': 'Missatge',
  'Muchas gracias.': 'Moltes gràcies.',
  'Página no encontrada': 'Pàgina no trobada',
  'Forma de envío': 'Forma d’enviament',
  'Método de pago': 'Mètode de pagament',
  'Descarga por link': 'Descàrrega per enllaç',
  'Servidor FTP': 'Servidor FTP',
  'Descargar': 'Descarregar',
  'Cuenta de Paypal': 'Compte de Paypal',
  'Cuenta de Bizum': 'Compte de Bizum',
  'Cargando': 'Carregant...',
  'Serás redirigido a Stripe para completar el pago con tarjeta': 'Seràs redirigit a Stripe per completar el pagament amb targeta',
  'Error al obtener la URL de Stripe': 'Error en obtenir la URL de Stripe',
  'Error con Stripe:': 'Error amb Stripe:',
  'Solicitar cuenta de Bizum por email': 'Sol·licitar compte de Bizum per email',
};
